import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { ListModalContextProvider } from './context/ListModalContextProvider';

import { ListHeader } from './header/ListHeader';
import { ListTable } from './table';
import { Modals } from './modals';

import { TABLE_COLUMNS } from './constants';

export const ListDisplay = () => (
  <SortingContextProvider
    defaultSortField={TABLE_COLUMNS.NAME}
    defaultSortDirection={SORT_DIRECTIONS.ASCENDING}
  >
    <ListModalContextProvider>
      <ListHeader />
      <ListTable />
      <Modals />
    </ListModalContextProvider>
  </SortingContextProvider>
);
